/**
 * Meta Pixel Tracking Module
 * 
 * Configure META_PIXEL_ID in your .env file to enable tracking
 * REACT_APP_META_PIXEL_ID=your_pixel_id
 */

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

// Initialize Meta Pixel
export function initMetaPixel() {
  if (!META_PIXEL_ID) {
    console.log('Meta Pixel: No pixel ID configured (REACT_APP_META_PIXEL_ID)');
    return;
  }

  // Facebook Pixel Code
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
  
  console.log('Meta Pixel initialized:', META_PIXEL_ID);
}

// Track Page View
export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
}

// Track View Content (Product/Look page)
export function trackViewContent(content) {
  if (window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: content.name,
      content_category: content.category,
      content_ids: [content.id],
      content_type: content.type || 'product',
      value: content.price / 100,
      currency: 'EUR'
    });
  }
}

// Track Search
export function trackSearch(searchTerm) {
  if (window.fbq) {
    window.fbq('track', 'Search', {
      search_string: searchTerm
    });
  }
}

// Track Add to Cart
export function trackAddToCart(item) {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: item.name,
      content_ids: [item.id],
      content_type: item.type || 'product',
      value: item.price / 100,
      currency: 'EUR'
    });
  }
}

// Track Initiate Checkout
export function trackInitiateCheckout(cart) {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_ids: cart.items.map(i => i.id),
      content_type: 'product',
      num_items: cart.items.length,
      value: cart.total / 100,
      currency: 'EUR'
    });
  }
}

// Track Add Payment Info
export function trackAddPaymentInfo(value) {
  if (window.fbq) {
    window.fbq('track', 'AddPaymentInfo', {
      value: value / 100,
      currency: 'EUR'
    });
  }
}

// Track Purchase
export function trackPurchase(order) {
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      content_ids: order.items.map(i => i.id),
      content_type: 'product',
      num_items: order.items.length,
      value: order.total / 100,
      currency: 'EUR',
      order_id: order.order_number
    });
  }
}

// Track Lead (Newsletter, Quiz)
export function trackLead(source) {
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: source
    });
  }
}

// Track Complete Registration
export function trackCompleteRegistration() {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration');
  }
}

// Track Quiz Complete
export function trackQuizComplete(results) {
  if (window.fbq) {
    window.fbq('trackCustom', 'QuizComplete', {
      style: results.style,
      occasion: results.occasion
    });
  }
}

// Generic custom event
export function trackCustomEvent(eventName, data = {}) {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, data);
  }
}

export default {
  initMetaPixel,
  trackPageView,
  trackViewContent,
  trackSearch,
  trackAddToCart,
  trackInitiateCheckout,
  trackAddPaymentInfo,
  trackPurchase,
  trackLead,
  trackCompleteRegistration,
  trackQuizComplete,
  trackCustomEvent
};
